import { combineReducers } from 'redux';

import { IApplicationState, TReduxActions } from '../types/redux';
import { IFiltersState } from '../types/filters';
import { detailsVisiblePrecisionReducer } from './detailsVisiblePrecision';
import { drawingReducer } from './drawing';
import { extendedQueryStringReducer } from './extendedQueryString';
import { featuresReducer } from './features';
import { filtersUrlReducer } from './filtersUrl';
import { isNewbuildingsListingReducer } from './isNewbuildingsListing';
import { jsonQueryReducer } from './filters';
import { lastActionReducer } from './lastAction';
import { listingUrlReducer } from './listingUrl';
import { mapBoundsReducer } from './mapBounds';
import { notificationsReducer } from './notifications';
import { queryStringReducer } from './queryString';
import { resultsReducer } from './results';
import { rulerReducer } from './ruler';
import { saveSearchReducer } from './saveSearch';
import { searchResultsReducer } from './searchResults';
import { specialPromosReducer } from './specialPromos';
import { tagsReducer } from './filters/tags';
import { userReducer } from './user';
import { activeFeatureReducer } from './activeFeature';
import { experimentsReducer } from './experiments';

export const reducers = combineReducers<IApplicationState, TReduxActions>({
  detailsVisiblePrecision: detailsVisiblePrecisionReducer,
  extendedQueryString: extendedQueryStringReducer,
  features: featuresReducer,
  filters: combineReducers<IFiltersState, TReduxActions>({
    jsonQuery: jsonQueryReducer,
    tags: tagsReducer,
  }),
  filtersUrl: filtersUrlReducer,
  isNewbuildingsListing: isNewbuildingsListingReducer,
  drawing: drawingReducer,
  lastAction: lastActionReducer,
  listingUrl: listingUrlReducer,
  experiments: experimentsReducer,
  mapBounds: mapBoundsReducer,
  notifications: notificationsReducer,
  queryString: queryStringReducer,
  results: resultsReducer,
  ruler: rulerReducer,
  saveSearch: saveSearchReducer,
  searchResults: searchResultsReducer,
  activeFeature: activeFeatureReducer,
  specialPromos: specialPromosReducer,
  user: userReducer,
});
